import services from './services/index.js';

/**
 * Run this script directly in the browser DevTools console after logging in as Admin!
 * Or call window.runDummyDataSeeder()
 */
export async function seedDatabase() {
  console.log("%c🚀 Starting Automated Dummy Data Seeder for Hostinger DB...", "color: #2563eb; font-size: 16px; font-weight: bold;");

  const logs = [];
  const log = (msg, isErr = false) => {
    if (isErr) console.error(`❌ ${msg}`);
    else console.log(`✅ ${msg}`);
    logs.push(msg);
  };

  try {
    // 1. DEPARTMENTS
    log("1/9 Creating Departments...");
    const deptsToCreate = [
      { departmentName: "Computer Science & Engineering", departmentCode: "CSE", status: "ACTIVE" },
      { departmentName: "Electronics & Communication", departmentCode: "ECE", status: "ACTIVE" },
      { departmentName: "Mechanical Engineering", departmentCode: "MECH", status: "ACTIVE" },
      { departmentName: "Business Administration", departmentCode: "MBA", status: "ACTIVE" }
    ];
    
    for (const d of deptsToCreate) {
      try {
        await services.department.createDepartment(d);
        log(`Created Dept: ${d.departmentName}`);
      } catch (err) {
        log(`Dept '${d.departmentName}' notice: ${err.message}`, true);
      }
    }

    const allDepts = await services.department.getAllDepartments().catch(() => []);
    const deptsList = Array.isArray(allDepts) ? allDepts : (allDepts?.data || []);
    const cseDept = deptsList.find(d => d.departmentCode === 'CSE' || (d.departmentName && d.departmentName.includes('Computer'))) || deptsList[0];
    const deptId = cseDept ? (cseDept.id || cseDept.departmentId) : null;
    const deptName = cseDept ? (cseDept.departmentName || cseDept.name) : "Computer Science & Engineering";

    // 2. COURSES
    log("2/9 Creating Courses...");
    const coursesToCreate = [
      { courseName: "B.Tech Computer Science", courseCode: "BT-CSE", durationYears: 4, departmentId: deptId },
      { courseName: "B.Tech Electronics", courseCode: "BT-ECE", durationYears: 4, departmentId: deptId },
      { courseName: "Master of Business Administration", courseCode: "MBA-GEN", durationYears: 2, departmentId: deptId }
    ];
    for (const c of coursesToCreate) {
      try {
        await services.course.createCourse(c);
        log(`Created Course: ${c.courseName}`);
      } catch (err) {
        log(`Course '${c.courseName}' notice: ${err.message}`, true);
      }
    }
    const allCourses = await services.course.getAllCourses().catch(() => []);
    const coursesList = Array.isArray(allCourses) ? allCourses : (allCourses?.data || []);
    const csCourse = coursesList[0];
    const courseId = csCourse ? (csCourse.id || csCourse.courseId) : null;
    const courseName = csCourse ? (csCourse.courseName || csCourse.name) : "B.Tech Computer Science";

    // 3. CLASSES
    log("3/9 Creating Classes...");
    const classesToCreate = [
      { className: "1st Year - Sec A", section: "A", academicYear: "2025-2026", courseId: courseId, capacity: 60, maxCapacity: 60 },
      { className: "2nd Year - Sec A", section: "A", academicYear: "2025-2026", courseId: courseId, capacity: 60, maxCapacity: 60 }
    ];
    for (const cl of classesToCreate) {
      try {
        await services.class.createClass(cl);
        log(`Created Class: ${cl.className}`);
      } catch (err) {
        log(`Class '${cl.className}' notice: ${err.message}`, true);
      }
    }
    const allClasses = await services.class.getAllClasses().catch(() => []);
    const classesList = Array.isArray(allClasses) ? allClasses : (allClasses?.data || []);
    const targetClass = classesList[0];
    const classId = targetClass ? (targetClass.id || targetClass.classId) : null;

    // 4. TEACHERS
    log("4/9 Creating Teachers...");
    const teachersToCreate = [
      { 
        teacherId: "T101", 
        name: "Dr. Robert Langdon",
        teacherName: "Dr. Robert Langdon", 
        gmail: "robert.langdon@college.edu", 
        email: "robert.langdon@college.edu",
        phoneNumber: "9876543210", 
        phone: "9876543210",
        designation: "Professor", 
        departmentId: deptId,
        department: deptName,
        departmentName: deptName,
        dob: "1980-01-01",
        experience: 5,
        address: "123 Campus Road",
        qualifications: "Ph.D. Computer Science",
        password: "teacher123"
      },
      { 
        teacherId: "T102", 
        name: "Prof. Sarah Connor",
        teacherName: "Prof. Sarah Connor", 
        gmail: "sarah.connor@college.edu", 
        email: "sarah.connor@college.edu",
        phoneNumber: "9876543211", 
        phone: "9876543211",
        designation: "Assistant Professor", 
        departmentId: deptId,
        department: deptName,
        departmentName: deptName,
        dob: "1985-05-15",
        experience: 3,
        address: "456 College Lane",
        qualifications: "M.Tech CSE",
        password: "teacher123"
      }
    ];
    for (const t of teachersToCreate) {
      try {
        await services.teacher.createTeacher(t);
        log(`Created Teacher: ${t.teacherName}`);
      } catch (err) {
        log(`Teacher '${t.teacherName}' notice: ${err.message}`, true);
      }
    }

    // 5. SUBJECTS
    log("5/9 Creating Subjects...");
    const subjectsToCreate = [
      { subjectName: "Data Structures & Algorithms", subjectCode: "CS201", credits: 4, courseId: courseId },
      { subjectName: "Database Management Systems", subjectCode: "CS202", credits: 4, courseId: courseId },
      { subjectName: "Operating Systems", subjectCode: "CS203", credits: 3, courseId: courseId }
    ];
    for (const s of subjectsToCreate) {
      try {
        await services.subject.createSubject(s);
        log(`Created Subject: ${s.subjectName}`);
      } catch (err) {
        log(`Subject '${s.subjectName}' notice: ${err.message}`, true);
      }
    }

    // 6. STUDENTS
    log("6/9 Creating Students...");
    const studentsToCreate = [
      { 
        name: "Alex Mercer",
        studentName: "Alex Mercer", 
        usn: "1CS21001", 
        studentId: "1CS21001", 
        email: "alex.mercer@student.edu", 
        phone: "9123456781", 
        phoneNumber: "9123456781",
        gender: "MALE", 
        dob: "2003-05-14", 
        classId: classId, 
        courseId: courseId, 
        departmentId: deptId,
        departmentName: deptName,
        courseName: courseName,
        academicYear: "2025-2026",
        semester: "1",
        scholarshipStatus: "NOT_APPLIED",
        parentName: "John Mercer",
        parentPhone: "9876543290"
      },
      { 
        name: "Emily Clarke",
        studentName: "Emily Clarke", 
        usn: "1CS21002", 
        studentId: "1CS21002", 
        email: "emily.clarke@student.edu", 
        phone: "9123456782", 
        phoneNumber: "9123456782",
        gender: "FEMALE", 
        dob: "2003-08-22", 
        classId: classId, 
        courseId: courseId, 
        departmentId: deptId,
        departmentName: deptName,
        courseName: courseName,
        academicYear: "2025-2026",
        semester: "1",
        scholarshipStatus: "NOT_APPLIED",
        parentName: "David Clarke",
        parentPhone: "9876543291"
      },
      { 
        name: "Michael Scott",
        studentName: "Michael Scott", 
        usn: "1CS21003", 
        studentId: "1CS21003", 
        email: "michael.scott@student.edu", 
        phone: "9123456783", 
        phoneNumber: "9123456783",
        gender: "MALE", 
        dob: "2002-11-10", 
        classId: classId, 
        courseId: courseId, 
        departmentId: deptId,
        departmentName: deptName,
        courseName: courseName,
        academicYear: "2025-2026",
        semester: "1",
        scholarshipStatus: "NOT_APPLIED",
        parentName: "George Scott",
        parentPhone: "9876543292"
      }
    ];
    for (const st of studentsToCreate) {
      try {
        await services.student.createStudent(st);
        log(`Created Student: ${st.studentName} (${st.usn})`);
      } catch (err) {
        log(`Student '${st.studentName}' notice: ${err.message}`, true);
      }
    }

    // 7. HOSTEL
    log("7/9 Creating Hostel & Rooms...");
    try {
      const hostel = await services.hostel.createHostel({ 
        hostelName: "Newton Hall (Boys)", 
        name: "Newton Hall (Boys)",
        totalRooms: 10,
        bedsPerRoom: 2,
        capacity: 20, 
        type: "BOYS" 
      });
      const hostelId = hostel ? (hostel.id || hostel.hostelId || hostel.data?.id) : null;
      if (hostelId) {
        await services.hostel.createHostelRoom(hostelId, { roomNumber: "101", capacity: 2, fee: 45000 }).catch(() => {});
        await services.hostel.createHostelRoom(hostelId, { roomNumber: "102", capacity: 2, fee: 45000 }).catch(() => {});
      }
      log("Created Hostel Newton Hall & Rooms 101, 102");
    } catch (err) {
      log(`Hostel notice: ${err.message}`, true);
    }

    // 8. VEHICLES
    log("8/9 Creating Vehicles...");
    try {
      await services.vehicle.createVehicle({ 
        registrationNumber: "KA-01-EQ-1234",
        vehicleNumber: "KA-01-EQ-1234", 
        vehicleModel: "Tata Starbus 40-Seater", 
        capacity: 40, 
        driverName: "John Doe", 
        driverPhone: "9988776655" 
      });
      log("Created Vehicle KA-01-EQ-1234");
    } catch (err) {
      log(`Vehicle notice: ${err.message}`, true);
    }

    // 9. LIBRARY
    log("9/9 Library ready (0 dummy books).");

    console.log("%c🎉 Dummy Data Seeding Complete on Hostinger Server!", "color: #16a34a; font-size: 18px; font-weight: bold;");
    console.table(logs);
    return { success: true, logs };

  } catch (globalErr) {
    console.error("Critical Seeding Failure:", globalErr);
    return { success: false, error: globalErr.message, logs };
  }
}

if (typeof window !== 'undefined') {
  window.runDummyDataSeeder = seedDatabase;
}

